import Vue from "vue";
import VueNumberFormat from '@coders-tm/vue-number-format'
Vue.use(VueNumberFormat, {decimal: ',', separator: '.', precision: 2});